import React, { useEffect, useState } from "react";
import TaskInformation from "../TaskInformation";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import PreviewButton from "../PreviewButton";
import ValidationButton from "../ValidationButton";
import {
    getAllMotifs,
    getAllServiceType,
    getSubMotifsByMotif,
    updateServiceProposal
} from "../../../store/action/claimManagement";
import {useDispatch, useSelector} from "react-redux";
import {completeTask, getTask} from "../../../store/action/taskAction";
import { fetchMessageEvents,updateMessageEvent } from "../../../store/action/communicationChannel";
import {createCommunicationChannel, updatePerson} from "../../../store/action/party";
import {useNavigate, useParams} from "react-router-dom";
import tunisiaData from '../../../utils/tunisiaData';
import ErrorsAlert from "../../../utils/errorsAlert";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
       position: 'relative',

    },
    paper: {
        display: "flex",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    leftSection: {
        flex: 1,
        padding: "40px",
    },
    rightSection: {
        flex: 1,
        padding: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12
    },
    inputTextArea: {
        width: "100%",
        marginBottom: "20px",
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "100%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    previewBtn: {
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '-165px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

const ServiceProposal = () => {
    const { taskId } = useParams();

    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [motifs, setMotifs] = useState([]);
    const [subMotifs, setSubMotifs] = useState([]);
    const [selectedMotif, setSelectedMotif] = useState("");
    const [dateDeplacement, setDateDeplacement] = useState("");
    const [comment, setComment] = useState("");
    const [motif, setMotif] = useState("");
    const [subMotif, setSubMotif] = useState("");
    const [proposedService, setProposedService] = useState("");
    const [clientDecision, setClientDecision] = useState("");
    const [gouvernorat, setGouvernorat] = useState("");
    const [region, setRegion] = useState("");
    const [proposedServiceId, setProposedServiceId] = useState(null);
    const [messageEvents, setMessageEvents] = useState([]);
    const [contactClient, setContactClient] = useState("");
    const username = localStorage.getItem('username');
    const [errors, setErrors] = useState([]);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [proposedServiceCamunda, setProposedServiceCamunda] = useState()
    const [managementType, setManagementType] = useState()
    const [customerPartyUid, setCustomerPartyUid] = useState()
    const [variables, setVariables] = useState()
    const [claimType, setClaimType] = useState()
    const [infoSinistre, setInfoSinistre] = useState()

    const classes = useStyles();
    const dispatch = useDispatch();

    const taskReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
        const fetchTask = async () => {
                    try {
                        const response = await getTask(taskId, username);
                        setTask(response)
                        setClaimType(response.variables.managementType.value)
                        setProposedServiceCamunda(response.variables?._proposedService?.value)
                        setManagementType(response.variables?._proposedService?.value)
                        setInfoSinistre(task?.businessKey)
                        setCustomerPartyUid(task?.variables?.customerPartyUid?.value)
                        setVariables(task?.variables)
                    } catch (error) {
                        console.error(`Error fetching task details: ${error.message}`);
                    }
                };
    useEffect(() => {
      
        fetchTask();

    }, [dispatch, taskId, username]);

    // const claimTypeReducer = useSelector((state) => state.taskReducer.taskList.find(task => task.taskId === taskId)?.variables?.claimType?.value);
    // const [claimType, setClaimType] = useState(claimTypeReducer);

    // // console.log("task", task)

    // const [infoSinistre, setInfoSinistre] = useState(task?.businessKey)

    // const managementTypeReducer = useSelector((state) => state.taskReducer.taskList.find(task => task.taskId === taskId)?.variables?.managementType?.value);
    // const [managementType, setManagementType] = useState(managementTypeReducer)
    // // console.log("managementType", managementType)

    // const proposedServiceCamundaReducer = useSelector((state) => state.taskReducer.taskList.find(task => task?.taskId === taskId)?.variables?._proposedService?.value);
    // const [proposedServiceCamunda, setProposedServiceCamunda] = useState(proposedServiceCamundaReducer)

    //const customerPartyUid = task?.variables?.customerPartyUid?.value;
    // const [customerPartyUid, setCustomerPartyUid] = useState(task?.variables?.customerPartyUid?.value)

    // const [variables, setVariables] = useState(task?.variables)
    //console.log("variables", variables)
    const navigate = useNavigate();
    const fetchData = async () => {
            const serviceData = await dispatch(getAllServiceType());
            const motifData = await dispatch(getAllMotifs());
            setServiceTypes(serviceData);
            setMotifs(motifData);
        };
    useEffect(() => {

        setContactClient(task?.variables?.customerContact?.value);
        setVariables(task?.variables)
         
    }, [dispatch, task, variables]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        const fetchServiceProposal = async () => {
            if (task && task?.variables && task?.variables._proposedServiceId) {
                setProposedServiceId(task?.variables._proposedServiceId.value);
                // console.log("proposedService--", proposedService)
            } else {
                // console.log("variables is null");
            }
        }
        fetchServiceProposal()
    }, [task]);
    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
      };
    const handleMotifChange = async (motifId) => {
        setSelectedMotif(motifId);
        setMotif(motifId);
        if (motifId) {
            try {
                const subMotifData = await getSubMotifsByMotif(motifId);
                setSubMotifs(subMotifData);
            } catch (error) {
                console.error('Error fetching sub-motifs:', error);
            }
        } else {
            setSubMotifs([]);
        }
    };
    const ValidationAction = async () => {
        try {
            let serviceProposalObject = {
                "proposedService": proposedServiceCamunda,
                "clientDecision": clientDecision,
                "comment": comment,
                "region": region,
                "gouvernorat": gouvernorat
            };
            

            if (contactClient != task?.variables?.customerContact?.value ) {
                setVariables(task.variables.customerContact = {
                    "value": contactClient,
                    "type": "String"
                })
                const communicationChannelResponse = await dispatch(createCommunicationChannel({
                    type: "PHONECONTACT",
                    value: contactClient
                }));
                const communicationChannelId = communicationChannelResponse._id;

                await dispatch(updatePerson(customerPartyUid, {
                    partyCommunicationChannels: [communicationChannelId]
                }));
            }


            if (!clientDecision){
                errors.push("Veuillez renseigner la décision du client")
            }
            if (clientDecision === "REFUSAL") {
                serviceProposalObject.clientDecisionMotif = motif;
                if (!motif) {
                    errors.push("Veuillez renseigner le motif")
                }

                // serviceProposalObject.clientDecisionSubMotif = subMotif;
                
            } else if (clientDecision === "ACCEPTANCE") {
                serviceProposalObject.estimatedCarDeposalDate = dateDeplacement;
                      
            if (!dateDeplacement)   {
                errors.push("Veuillez renseigner la date de déplacement")

            }
            if (!gouvernorat) {
                errors.push("Veuillez renseigner le gouvernorat")

            }
       

            }
     
            if (errors.length > 0) { 
                setErrors(errors);
                setOpenErrorDialog(true);
                return;
            }
          
            await updateServiceProposal(proposedServiceId, serviceProposalObject);

            //let variables = {};

            // det if managementType needs to be updated based on motif code
            if (selectedMotif && motifs.find(m => m._id === selectedMotif)?.code === "MT014") {
                setVariables(variables.managementType = {
                    "value": "AUTOP",
                    "type": "String"
                })
            }

            // Find the service object by ID
            const selectedService = claimType;
            // ("selectedService", selectedService)
            // ("clientDecision", clientDecision)
            if (selectedService) {
                // Determine which Camunda variable to set based on service type and client decision
                setVariables(variables.serviceProposalClientDecision = {
                    "value": clientDecision,
                    "type": "String"
                })
                if (clientDecision === "REFUSAL") {
                    setVariables(variables.serviceProposalRefusalMotif = {
                        "value": motif,
                        "type": "String"
                    }) }
            }
            if (dateDeplacement !== "") {
                setVariables(variables.serviceProposalDateDeplacement = {
                    "value": dateDeplacement,
                    "type": "String"
                })
            }
            
            const messageEvents = await dispatch(fetchMessageEvents('STEP_SERVICE_PROPOSAL', infoSinistre));
            if (messageEvents && messageEvents.length > 0) {
                const messageEventId = messageEvents[0]._id; // Assuming you want to update the first one found
                await dispatch(updateMessageEvent(messageEventId, {status: 'CLOSED'}));
            }
            // If update is successful, complete the task with variables
            await dispatch(completeTask(taskId, username, variables));

             
     
        navigate('/todo-list', { reload: true });
         
        } catch (error) {
        
            console.error(error);
            alert("Erreur lors de la validation. Veuillez réessayer.");
        }
    };

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task]);





    
      const handleGovernorateChange = (e) => {
        setGouvernorat(e.target.value);
        setRegion('');  
      };

      const handleDelegationChange = (e) => {
        setRegion(e.target.value);
      };
    
    return (
        <>
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
                <div className={classes.mainContent}>
                    <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed}/>
                    <Paper className={classes.paper}>
                        <div className={classes.leftSection}>
                            <div>
                                <label className={classes.inputLabel}>Type de service</label>
                                {/*<select*/}
                                {/*    className={classes.inputContainer}*/}
                                {/*    name="proposedService"*/}
                                {/*    disabled={isTaskClaimed}*/}
                                {/*    onChange={(e) => setProposedService(e.target.value)}*/}
                                {/*>*/}
                                {/*    <option value=""></option>*/}
                                {/*    {serviceTypes.map((service, index) => (*/}
                                {/*        <option key={index} value={service._id}>{service.label}</option>*/}
                                {/*    ))}*/}
                                {/*</select>*/}
                                <select
                                    className={classes.inputContainer}
                                    name="proposedService"
                                    disabled
                                    onChange={(e) => setProposedService(e.target.value)}
                                    value={claimType}
                                >
                                    <option>
                                        {claimType}
                                    </option>
                                </select>
                            </div>
                            <div>
                                <label className={classes.inputLabel}>Décision client</label>
                                <select
                                    className={classes.inputContainer}
                                    name="clientDecision"
                                    disabled={isTaskClaimed}
                                    onChange={(e) => setClientDecision(e.target.value)}
                                >
                                    <option value=""></option>
                                    <option value="ACCEPTANCE">Acceptation</option>
                                    <option value="REFUSAL">Refus</option>
                                    <option value="WAITING_FOR_DECISION">En attente de décision</option>
                                    <option value="CLIENT_NOT_REACHABLE">Client injoignable</option>
                                    <option value="CLAIM_UNDER_500">Dossier Inférieur à 500</option>
                                </select>
                            </div>
                            {clientDecision === "REFUSAL" && (
                                <><div> {/* Render motif field only if clientDecision is REFUSAL */}
                                    <label className={classes.inputLabel}>Motif</label>
                                    <select
                                        className={classes.inputContainer}
                                        name="motif"
                                        disabled={isTaskClaimed}
                                        onChange={(e) => handleMotifChange(e.target.value)}
                                    >
                                        <option value=""></option>
                                        {motifs.map((motif, index) => (
                                            <option key={index} value={motif._id}>{motif.label}</option>
                                        ))}
                                    </select>
                                </div>{subMotifs.length > 0 && (
                                    <div>
                                        <label className={classes.inputLabel}>Sous Motif</label>
                                        <select
                                            className={classes.inputContainer}
                                            name="subMotif"
                                            disabled={isTaskClaimed}
                                            onChange={(e) => setSubMotif(e.target.value)}
                                        >
                                            <option value=""></option>
                                            {subMotifs.map((subMotif, index) => (
                                                <option key={index} value={subMotif._id}>{subMotif.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}</>
                            )}
                           
                            <div>
                                <label className={classes.inputLabel}>N° Téléphone Client</label>
                                <input
                                    className={classes.inputContainer}
                                    type="text"
                                    value={contactClient}
                                    onChange={(e) => setContactClient(e.target.value)}
                                    disabled={isTaskClaimed}
                                />
                            </div>
                            {clientDecision === "ACCEPTANCE" && (
                                <>
                                <div>
                                    <label className={classes.inputLabel}>Date prévu déplacement client</label>
                                    <input
                                        className={classes.inputContainer}
                                        name="dateDeplacement"
                                        type="date"
                                        disabled={isTaskClaimed}
                                        value={dateDeplacement}
                                        onChange={(e) => setDateDeplacement(e.target.value)}
                                        placeholder=""
                                        min={new Date().toISOString().split('T')[0]}
                                        style={{ background: 'rgba(243, 246, 249, 1)' }} />
                                </div>
                                <div>
                                        <label className={classes.inputLabel}>Gouvernat de réparation</label>
                                        <select value={gouvernorat} className={classes.inputContainer} disabled={isTaskClaimed} onChange={handleGovernorateChange}>
                                            <option value="">Choisissez un gouvernorat</option>
                                            {Object.keys(tunisiaData).map((governorate, index) => (
                                                <option key={index} value={governorate}>{governorate}</option>
                                            ))}
                                        </select>
                                        <label className={classes.inputLabel}>Région de réparation</label>

                                        <select value={region}  className={classes.inputContainer} disabled={isTaskClaimed} onChange={handleDelegationChange}>
                                            <option value="">Choisissez une délégation</option>
                                            {tunisiaData[gouvernorat] && tunisiaData[gouvernorat].map((delegation, index) => (
                                                <option key={index} value={delegation}>{delegation}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>


                                </div>
                                    </>)}
                            
                        </div>
                        <div className={classes.rightSection}>

                            <label className={classes.inputLabel}>Commentaire</label>
                            <br/>
                            <textarea
                                className={classes.inputTextArea}
                                style={{
                                    background: "rgba(243, 246, 249, 1)",
                                    width: "519px",
                                    height: 340,
                                    borderRadius: "4px",
                                    border: "none",
                                    outline: "none",
                                    padding: "40px",
                                }}
                                disabled={isTaskClaimed}
                                onChange={(e) => setComment(e.target.value)}
                            ></textarea>
                        </div>
                    </Paper>
                </div>
                <PreviewButton claimData={infoSinistre}/>
            </div>
            <ValidationButton taskId={taskId}  handleValidation={() =>isTaskClaimed? null : ValidationAction()}/>
        </div>
     <ErrorsAlert
        open={openErrorDialog}
        errors={errors}
        handleClose={handleClose}
      /></>
    );
};

export default ServiceProposal;
